export default "__VITE_ASSET__CvW1joS9__"